import abort from '../../../javascripts/utils/abort';
import onLoad from '../../../javascripts/utils/onLoad';

onLoad<HTMLElement>('.logo-slider', ($logoSlider) => {
  const $logos = $logoSlider.querySelector('.logo-slider__logos') ?? abort();
  const $firstLogo = $logos.querySelector('.logo-slider__logo') ?? abort();
  const $leftButton = $logoSlider.querySelector<HTMLButtonElement>('[data-logo-slider="left"]') ?? abort();
  const $rightButton = $logoSlider.querySelector<HTMLButtonElement>('[data-logo-slider="right"]') ?? abort();

  const onScroll = () => {
    $leftButton.disabled = $logos.scrollLeft <= $firstLogo.clientWidth;
    $rightButton.disabled = $logos.scrollLeft >= ($logos.scrollWidth - $logos.clientWidth - $firstLogo.clientWidth);
  };

  $logos.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  onScroll();

  $leftButton.addEventListener('click', (event) => {
    event.preventDefault();
    $logos.scrollBy({ left: $logos.clientWidth * -1 });
  });

  $rightButton.addEventListener('click', (event) => {
    event.preventDefault();
    $logos.scrollBy({ left: $logos.clientWidth });
  });
});
